<template>
    <b-row class="vh-100" align-v="center" >
        <b-col cols="12" md="8" offset-md="2" align-self="center">
            <b-row align-h="center">
                <b-col cols="12" align-self="center" style="text-align:center" class="mb-5">
                     Payments onboarding
                </b-col>

                <b-col cols="12" align-self="center" class="form">
                    Here we start with onboarding with payments
                </b-col>

                <b-col cols="12" align-self="center" class="mt-5">
                    <b-button variant="success" @click="success" block>{{ $t('continue') }}</b-button>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
import OnboardingLayout from '@/components/integrations/OnboardingLayout.vue'

export default {
    components: {
        OnboardingLayout
    },

    data: function() {
        return {}
    },

    methods: {
        async success() {
            try {
                const { data } = await this.$store.dispatch('updateIntegrationOnboarding', {
                    integrationId: 'monri',
                    step: "choose_provider",
                    data: {
                        provider: ["monri"]
                    }
                })

                if (data.onboarding.status == 'completed') {
                    this.$emit('onboardingSuccess', 'integration', 'monri')
                }
            } catch(err) {
                console.error(err)
                
                this.$bvToast.toast(this.$t('unexpectedError'), {
                    variant: 'danger'
                })
            }
        }
    },

    mounted() {}
}
</script>